import React from "react";
import { Aboutsec1, Aboutsec2 } from "./components/Aboutcomponent";
import { Sec2, Sec3, Sec5 } from "./components/Homecomponent";
import PageHeader from "./components/PagesHeaderComponent/PageHeader";
import regulationImg from "../assets/images/regulations.png"
import notificationImg from "../assets/images/notification.png"
import { Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom/dist";

const DirectorshipApplication = () => {

	const navigate = useNavigate();
	const data = [
		{
			title: "CDC House",
			desc: "Associate Professor of Finance",
			date: "Application Deadline: 10 March 2024"
		},
		{
			title: "Company name",
			desc: "Associate Professor of Finance",
			date: "Application Deadline: 10 March 2024"

		},
		{
			title: "Company name",
			desc: "Associate Professor of Finance",
			date: "Application Deadline: 10 March 2024"

		},
		{
			title: "CDC House",
			desc: "Associate Professor of Finance",
			date: "Application Deadline: 10 March 2024"
		},
		{
			title: "Company name",
			desc: "Associate Professor of Finance",
			date: "Application Deadline: 10 March 2024"

		},
		{
			title: "Company name",
			desc: "Associate Professor of Finance",
			date: "Application Deadline: 10 March 2024"

		},
		{
			title: "CDC House",
			desc: "Associate Professor of Finance",
			date: "Application Deadline: 10 March 2024"
		},
		{
			title: "Company name",
			desc: "Associate Professor of Finance",
			date: "Application Deadline: 10 March 2024"

		},
		{
			title: "Company name",
			desc: "Associate Professor of Finance",
			date: "Application Deadline: 10 March 2024"

		},

	]

	const handleBtnClick = (data) => {
		navigate(`/DirectorshipApplication/${data.title}`, {
			state: {
				...data,
			},
		});
	}

	return (
		<>
			<PageHeader heading="Directorship Application" />
			<div className="content_wrap">

				<section className='sec sec9'>
					<div className='container'>

						<div className="cards_wrap">
							{data.map((e) => {
								return <>
									<Card className="directorApplicards">
										<h4>{e.title}</h4>
										<h5>{e.desc}</h5>
										<p>{e.date}</p>
										<Button className="card_btn" variant="primary" onClick={() => handleBtnClick(e)}>Read More</Button>
									</Card>


								</>
							})}
						</div>
					</div>
				</section>
			</div>

		</>
	);
};

export default DirectorshipApplication;
